import axios from 'axios'
export const bulkContactExportStatus = '/api/rest/wfo/contact/export/bulk/execution'

export async function getBulkContactExportStatus() {
  return await axios
    .get(bulkContactExportStatus)
    .then(res => (res.data ? res.data : []))
    .catch(e => {
      // eslint-disable-next-line no-console -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
      console.error('Network error during getBulkContactExportStatus', e)
      return []
    })
}
